import React, { useState, useEffect, useMemo, useCallback } from "react";
import router from "umi/router";
import { Select } from "antd";
import { connect, useLocation } from "dva";
import { getUrlParams, setUrlParams, validateGuid } from "@/utils/utils";

const { Option } = Select;

const EntityDropdown = props => {
  const { entities, dispatch } = props;

  const location = useLocation();

  const [selectValue, setSelectValue] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [isMobile, _] = useState(window.innerWidth <= 768);

  const shouldAddAllAccountsOption = useCallback(connectedEntities => {
    const onlyConnectedToOneEntity = connectedEntities.length === 1;
    const onlyConnectedToTransporters = connectedEntities?.every(e => e.type === 0);
    const connectedToAtLeastOneDealer = connectedEntities?.some(e => e.type === 1);

    if (onlyConnectedToOneEntity || onlyConnectedToTransporters) return false;
    if (connectedToAtLeastOneDealer) return true;

    return true;
  }, []);

  // get the right options for select
  const options = useMemo(() => {
    const entityOptions = entities?.map(e => {
      return { value: e.entityId, title: e.name };
    });

    if (shouldAddAllAccountsOption(entities)) {
      entityOptions.unshift({ value: "all", title: "All Accounts" });
    }

    return entityOptions;
  }, [entities?.length]);

  // set initial or default select value
  useEffect(() => {
    if (entities?.length) {
      const entityId = getUrlParams("entityId");
      const firstOption = options?.[0]?.value;
      const isAll = firstOption === "all";
      const value = entities.length === 1 ? entities[0]?.entityId : entityId || firstOption;
      const queryParamValue = isAll ? "" : value;

      queryParamValue && setUrlParams("entityId", queryParamValue);
      setSelectValue(value);
    }
  }, [entities?.length]);

  const changeEntity = value => {
    if (value) {
      const isAll = value === "all";
      const isValidated = isAll || validateGuid(value);

      if (isValidated) {
        router.push(`/dashboard${isAll ? "" : `?entityId=${value}`}`);
        setSelectValue(value);

        if (location.pathname === "/dashboard") {
          window.location.reload();
        } else {
          // Refresh current user data/roles when swapping selected entity
          dispatch({
            type: "user/fetchCurrent",
          });
        }
      }
    }
  };

  return (
    <Select
      style={{ minWidth: isMobile ? 50 : 200, marginRight: 12 }}
      onChange={changeEntity}
      value={selectValue}
      filterOption={(input, option) => {
        return option.title?.toLowerCase()?.indexOf(input?.toLowerCase()) > -1;
      }}
      showSearch
    >
      {options.map(o => (
        <Option key={o.value} value={o.value} title={o.title}>
          {o.title}
        </Option>
      ))}
    </Select>
  );
};

export default connect(({ user }) => ({
  entities: user.dealers,
  connectionRoleTypes: user.connectionRoleTypes,
}))(EntityDropdown);
